/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const lazyLoad = require('public/js/lib/image-lazy-load')();

	/********************************************
	 * Load Javascript for the Recommended products Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/
	(function ProductRecommmendedModule() {
		function HandleCartShippingQuoteResponse({$recommendedContentEle, $recommendedResponseEle}) {
			return function (evt, response) {
				$recommendedContentEle.addClass('has-recommendations');
				$recommendedResponseEle.html(response);

				const displayList = $recommendedContentEle.data('display-list');
				if(displayList) {
					// Reattach Image Lazy load
					lazyLoad.attach();

					// Reattach Add To Cart Button Events
					rp$('.search-listing-module').find('.add-to-cart.enabled').add_to_cart();
				} else {
					var $product_recommendations = $recommendedResponseEle.find('.recommendations');
					$product_recommendations.addClass('owl-carousel').owlCarousel({
						margin: 10,
						nav: true,
						navText: false,
						responsive: {
							0: {
								items: 2
							},
							500: {
								items: 4
							},
							800: {
								items: 7
							}
						}
					});
				}
			};
		}

		$onReady({
			rp$, window,
			label: 'product_recommended',
			fn: function () {
				var $product_recommended_modules = rp$('.product-recommended-module');


				rp$.each($product_recommended_modules, function DropDownMenu_Iterator(idx, product_recommended_module) {
					var $recommendedContentEle = rp$(product_recommended_module).find('.product-recommendations');
					var $recommendedResponseEle = rp$(product_recommended_module).find('.recommended-products-response');

					const eventHandler = HandleCartShippingQuoteResponse({
						$recommendedContentEle,
						$recommendedResponseEle,
					});

					/* Handle Recommendation Response
					.*-----------------------------------------*/
					// Due to plugin, all things that depend on document and window are up for causing bugs. Lets clean up before we start
					rp$(document).off('productGetRecommendations:response', eventHandler);
					rp$(document).on('productGetRecommendations:response', eventHandler);
				}); // END rp$.each module
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
